import { apiCall } from './_helper';

// Login function
// Tested & Working: 4/6/2025
export const companyLogin = async (submit) => {
  const dataform = new FormData(submit);
  return await apiCall({
    url: 'login',
    method: 'POST',
    body: dataform,
    checkSessionOut: true,
    noAuth: true,
    notJSON: true,
    onResponse: async (response) => {
      if (response.status >= 400) {
        sessionStorage.setItem('loggedIn', 'failed');
        throw new Error('Network request failed');
      }
      return await response.json();
    },
  });
};

// Triggered when the password reset form is submitted
// Tested & Working: 4/6/2025
export const postPasswordResetMail = async (email) => {
  const dataform = new FormData();
  dataform.append('username', email);
  return await apiCall({
    url: 'forgottenpassword/sendemail',
    method: 'POST',
    body: dataform,
    noAuth: true,
    notJSON: true,
  });
};

// Called from the page delivered by the email link
// Tested & Working: 4/6/2025
export const resetPassword = async (bodyParam) => {
  const dataform = new FormData();
  dataform.append('password', bodyParam.password);
  dataform.append('token', bodyParam.token);

  return await apiCall({
    url: 'forgottenpassword/resetpassword',
    method: 'PUT',
    body: dataform,
    noAuth: true,
    notJSON: true,
    onResponse: async (response) => {
      return await response.json();
    },
  });
};

export const verifySSOToken = async (token) => {
  return await apiCall({
    url: 'verifyEntraToken/verifyEntraToken',
    method: 'GET',
    noAuth: true,
    notJSON: true,
    headers: {
      Authorization: token,
    },
  });
};

// Verify OTP for MFA login
export const verifyOtp = async (submit, otpToken) => {
  const dataform = new FormData(submit);
  return await apiCall({
    url: 'verifyOtp',
    method: 'POST',
    body: dataform,
    checkSessionOut: true,
    noAuth: true,
    notJSON: true,
    headers: {
      Authorization: otpToken,
    },
    onResponse: async (response) => {
      if (response.status >= 400) {
        sessionStorage.setItem('loggedIn', 'failed');
        throw new Error('Network request failed');
      }
      return await response.json();
    },
  });
};

// Resend OTP for MFA login
export const resendOtp = async (otpToken) => {
  return await apiCall({
    url: 'resendOtp',
    method: 'POST',
    checkSessionOut: true,
    noAuth: true,
    notJSON: true,
    headers: {
      Authorization: otpToken,
    },
    onResponse: async (response) => {
      if (response.status >= 400) {
        sessionStorage.setItem('loggedIn', 'failed');
        throw new Error('Network request failed');
      }
      return await response.json();
    },
  });
};
